<template>  
    <section class="blockElement" >  
       
        <div class="container-fluid">
            <!-- <div class="riskWarningMsg d-md-none">
                <small>{{$t('riskWarningMsg')}}</small>
            </div> -->
            <div class="innerInclude p_login"> 
                
                <div class="row"> 
                    <div class="col-12 col-md-4 text-center d-flex blueBG beforeBG vh_100 align-items-center justify-content-center ">
                        <div class="d-none d-md-block">
                            <div class="titleArera Loginlogo">
                               <img src="../../../../static/fxView/images/fxview_logo_white.svg" alt="fxView">
                            </div>
                            <div class="PortfoliosTitle"> 
                                <div id="demo" class="carousel slide fxRegisterSteps " data-ride="carousel"> 
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <!-- <p>{{ $t('welcomeMsg') }}</p> -->
                                            <img src="../../../../static/fxView/images/login_trading_platform.svg" alt="Banner">
                                            <h3>{{$t('welcomeMsgHeadone')}}</h3>
                                            <p>{{$t('welcomeMsg1')}}</p>       
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../../../../static/fxView/images/login_trader_toolbox.svg" alt="Banner">
                                            <h3>{{$t('welcomeMsgHeadtwo')}}</h3>
                                            <p>{{$t('welcomeMsg2')}}</p>
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../../../../static/fxView/images/login_download_platform.svg" alt="Banner">
                                            <h3>{{$t('welcomeMsgHeadthree')}}</h3>
                                            <p>{{$t('welcomeMsg3')}}</p>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <ul class="carousel-indicators mt-3">
                                        <li data-target="#demo" data-slide-to="0" class="active"></li>
                                        <li data-target="#demo" data-slide-to="1"></li>
                                        <li data-target="#demo" data-slide-to="2"></li>
                                    </ul>
                                </div>
                            </div> 
                        </div>
                    </div>
                    <div class="col-12 col-md-8 d-flex p-0 vh_100 align-items-center">
                        <div class="sign_insec forgotpwdSec">
                            <div class="mobileLogo d-md-none">
                                <img src="../../../../static/fxView/images/fxview_logo.svg" alt="fxView">
                            </div>
                            <!--loader - message--->
                            <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                            <div class="subtitle" v-if="!resend">
                                <h3 class="mb-3"> {{$t('forgotPassword')}}</h3>
                                <p class="mb-3">{{$t('forgotPasswordText')}} </p>
                                <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                            </div>
                            <div class="mb-3 text-center" v-if="resend">
                                <img src="../../../../static/fxView/images/email_sent.svg" alt="email sent" width="60" class="mb-3">
                                <p>{{$t(response_msg)}}</p>    
                            </div>
							
                            <div class="stepForm"> 
                                <div class="form-group field-wrapper" v-if="!resend">
                                    <input   placeholder=" " type="text" name="Email" v-model="email" class="float-field form-control"  v-validate="'required|email'"   :class="{ 'is-invalid': submitted && errors.has('Email') }" ref="emailInput" />
                                    <label for="username" class="float-label">{{$t('emailaddress')}} </label> 
                                    <ul><li v-for="error in errors.collect('Email')">{{ error }}</li></ul>
                                </div> 
                                <div class="clearfix"></div>
                                <div class="d-flex justify-content-between align-items-center submitButton">
                                    <button class="prism_btn btn_sm" v-on:click="submit()">
										<span v-if="!resend">{{$t('resetPassword')}}</span> 
										<span v-if="resend">{{$t('RESEND_EMAIL')}}</span> 
									</button>
                                    <div class="forgot_sec">
                                        <router-link :to="'/'" class="forgotpassword d-flex">
                                            <feather type="chevron-left" size="1rem" class="mr-1"></feather>{{$t('backLogin')}}
                                        </router-link>     
                                    </div>
                                </div> 
                                <app-language> </app-language>  
                                <div class="charlgateMsg border-top pt-2 mt-2">
                                    <small>{{$t('charlgateMsg')}}</small>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div> 
            </div>
        </div>
		<div class="fixedBarBottom fullwidth register-page-fixedbar">
            <div class="footPromoLastBar  text-center">
                <p class="" v-html="$t('footerMsz2')"></p>
                <a :href="legalDocLink" target="_blank">{{$t('riskDisclaimer')}}</a> 
            </div>
		</div>
    </section> 
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
	import language from '../shared/language_before_login'
    export default {
        name: 'Forgot-password',
        mixins: [fxViewMixins],
        data() {
            return {
                "email" : "",
				resend : false,
                submitted: false,
                pageLoader : false,
                response_msg : '',
                msg_type   : '',      
            }
        },
		components: {
            appLanguage: language
        },
        methods:{
            ...mapActions({
                _runUserForgotPassword: types.RUN_USER_FORGOT_PASSWORD
            }),
            submit(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                "email": _that.email
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runUserForgotPassword(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/forgot_password.vue